import React, { useCallback, useMemo } from 'react';
import { Radio, Tooltip } from 'antd';

export const TreeMapType = {
  Buyer: 'Buyer',
  Target: 'Target',
  'New Territories': 'New Territories',
};

const Tip = (
  <Tooltip title="New territories are defined as territories where the buyer does not currently operate, and the target has a presence.">
    <span className="appkiticon icon-information-fill" />
  </Tooltip>
);

function TreeMapTypeRadio({ onChange, value, data = {} }) {
  const { buyerLabel, targetLabel, instanceType } = data;
  const RadioOptions = useMemo(() => {
    const options = Object.keys(TreeMapType);
    if (instanceType === 'Divestiture') {
      options.pop();
    }
    return options;
  }, [instanceType]);
  const getRadioText = useCallback(
    (radioKey) =>
      ({
        [TreeMapType.Buyer]: buyerLabel,
        [TreeMapType.Target]: targetLabel,
        [TreeMapType['New Territories']]: (
          <>
            {radioKey} {Tip}
          </>
        ),
      }[radioKey]),
    [data],
  );
  return (
    <div className="headcount-sales-radio">
      <Radio.Group onChange={onChange} value={value}>
        {RadioOptions.map((i) => (
          <Radio value={i}>{getRadioText(i)}</Radio>
        ))}
      </Radio.Group>
    </div>
  );
}

export default TreeMapTypeRadio;
